module.exports = __webpack_public_path__ + "static/media/file-chart-line.84350d2f.svg";